export default "__VITE_ASSET__DycSg8Kf__"